function ListSpecification(props) {
    let Points = props.list.map ((point, idx) =>
    {
        return ( 
            <li key={idx}>{point.li}</li>
        )
    });
return (
    <ul className='list-specification'>
        {Points} 
    </ul>
)}
export default ListSpecification;